<template functional>
  <svg
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="data.attrs"
    :class="$options.methods.mergeFunctionalRenderContextClasses(data)"
    viewBox="0 0 1103.13 834.15"
  ><defs><linearGradient
    id="a"
    x1="394.52"
    y1="617.07"
    x2="394.52"
    y2="476.78"
    gradientUnits="userSpaceOnUse"
  ><stop
    offset="0"
    stop-color="gray"
    stop-opacity=".25"
  /><stop
    offset=".54"
    stop-color="gray"
    stop-opacity=".12"
  /><stop
    offset="1"
    stop-color="gray"
    stop-opacity=".1"
  /></linearGradient></defs><path
    d="M51.17 330.86c16.83 46.21 52.45 86.21 108.75 105.6 117 40.27 380.86 19.5 577.78-4.34 101.87-12.33 191.39-46.35 256.43-94.26zM1083.85 113.16h-108c-5.13 0-9.34-2.7-9.34-6s4.21-6 9.34-6h18.68c-5.14 0-9.34-2.7-9.34-6s4.2-6 9.34-6h-13.34c-5.14 0-9.34-2.7-9.34-6s4.2-6 9.34-6h56.38c-12.51-3.75-27.1-6.41-44-7.8-153.8-12.72-208.71-4.29-228.08 4.32a287 287 0 01-79 22.28c-94.92 12.58-272.35 27.73-433.17-4.89-79.93-16.19-139.34 11.17-174.95 56.9h1024.25c-1.34-13.3-5.34-25.57-12.69-36.31a12.65 12.65 0 01-6.08 1.5zM42 234.32a198.53 198.53 0 004.19 80.69l948.67 22.31c26.26-19.44 48.51-41.16 65.91-64.63zm375.21 57.56h-18.64c5.13 0 9.33 2.71 9.33 6s-4.2 6-9.33 6h-108c-5.14 0-9.34-2.7-9.34-6s4.2-6 9.34-6h18.67c-5.13 0-9.34-2.7-9.34-6s4.21-6 9.34-6h-13.42c-5.13 0-9.34-2.71-9.34-6s4.21-6 9.34-6h108.05c5.14 0 9.34 2.7 9.34 6s-4.2 6-9.34 6h13.34c5.14 0 9.34 2.7 9.34 6s-4.2 6-9.34 6zM1102.66 148.42L66.94 164.62a190.42 190.42 0 00-24.8 68.78h1042.37a201.59 201.59 0 0015-43.84c3.15-14.34 4.39-28.22 3.15-41.14zM252.43 201.5h-18.68c5.14 0 9.34 2.71 9.34 6s-4.2 6-9.34 6h-108c-5.14 0-9.34-2.7-9.34-6s4.2-6 9.34-6h18.68c-5.14 0-9.34-2.7-9.34-6s4.2-6 9.34-6h-13.39c-5.14 0-9.34-2.71-9.34-6s4.2-6 9.34-6h108c5.13 0 9.33 2.7 9.33 6s-4.2 6-9.33 6h13.34c5.13 0 9.33 2.7 9.33 6s-4.14 6-9.28 6z"
    fill="#f5821f"
    opacity=".1"
  /><path
    fill="#535f89"
    d="M580.73 263.67h5.57v307.05h-5.57z"
  /><path
    d="M591.57 628.15a14.53 14.53 0 01-17.83 0c-2.49-16.43 3.83-48.72 5.32-56l.31-1.46h7.2a5 5 0 011.11 1.67c4.89 10.53 3.89 55.79 3.89 55.79z"
    fill="#535f89"
  /><path
    d="M585.06 564.07v6.63h-3v-6.63a8.72 8.72 0 011.46-.12 9.82 9.82 0 011.54.12zM587.63 572.39a8.5 8.5 0 01-4.12 1 8.15 8.15 0 01-4.43-1.18l.31-1.46h7.18a5 5 0 011.06 1.64z"
    opacity=".1"
  /><ellipse
    cx="583.51"
    cy="568.66"
    rx="6.01"
    ry="3.57"
    fill="#dce2ed"
  /><path
    fill="#f5821f"
    d="M557.1 214.21l21.16-10.13 31.2 7.46-24.21-18.3-28.15 20.97z"
  /><path
    fill="#f5821f"
    d="M563.29 217.45l-6.19-3.24 21.16-10.13 31.2 7.46-5.49 2.67-25.71-5.77-14.97 9.01z"
  /><path
    opacity=".1"
    d="M563.29 217.45l-6.19-3.24 21.16-10.13 31.2 7.46-5.49 2.67-25.71-5.77-14.97 9.01z"
  /><path
    fill="#f5821f"
    opacity=".2"
    d="M562.45 215.06l17.03 47.72h8.44l15.77-50.68-25.43-5.91-15.81 8.87z"
  /><path
    fill="#f5821f"
    d="M592.1 249.35l-3.36 10.82-.82 2.61h-8.44l-.63-1.77-3.98-11.15 6.39-3.84 10.84 3.33z"
  /><path
    fill="#f5821f"
    opacity=".2"
    d="M578.26 208.44l4.03 54.34h-2.81l-16.19-45.33 14.97-9.01z"
  /><path
    opacity=".1"
    d="M585.25 193.24l-6.99 10.84-21.16 10.13 28.15-20.97zM588.74 260.17l-.81 2.61h-8.45l-.63-1.77a7.07 7.07 0 015.42-2 8.11 8.11 0 014.47 1.16zM585.06 263.67v4.65h-.79a9.25 9.25 0 01-2.22-.26v-4.39z"
  /><ellipse
    cx="584.26"
    cy="263.67"
    rx="6.01"
    ry="3.57"
    fill="#dce2ed"
  /><path
    fill="#535f89"
    d="M799.08 413.01h3.68v203h-3.68z"
  /><path
    d="M806.26 653.98a9.6 9.6 0 01-11.78 0c-1.65-10.86 2.53-32.22 3.51-37 .13-.63.21-1 .21-1h4.71a3.34 3.34 0 01.74 1.1c3.26 6.99 2.61 36.9 2.61 36.9z"
    fill="#535f89"
  /><path
    d="M801.94 611.62v4.39h-2v-4.39a5 5 0 011-.08 6.69 6.69 0 011 .08z"
    opacity=".1"
  /><path
    d="M803.65 617.07a5.71 5.71 0 01-2.73.64 5.5 5.5 0 01-2.93-.77c.13-.63.21-1 .21-1h4.71a3.34 3.34 0 01.74 1.13z"
    opacity=".1"
  /><ellipse
    cx="800.92"
    cy="614.65"
    rx="3.97"
    ry="2.36"
    fill="#dce2ed"
  /><path
    fill="#f5821f"
    d="M783.46 380.31l13.99-6.7 20.63 4.94-16.01-12.1-18.61 13.86z"
  /><path
    fill="#f5821f"
    d="M787.55 382.45l-4.09-2.14 13.99-6.7 20.63 4.94-3.63 1.76-17-3.81-9.9 5.95z"
  /><path
    opacity=".1"
    d="M787.55 382.45l-4.09-2.14 13.99-6.7 20.63 4.94-3.63 1.76-17-3.81-9.9 5.95z"
  /><path
    fill="#f5821f"
    opacity=".2"
    d="M786.99 380.87l11.26 31.55h5.59l10.42-33.5-16.81-3.91-10.46 5.86z"
  /><path
    fill="#f5821f"
    d="M806.6 403.54l-2.22 7.16-.54 1.73h-5.59l-.41-1.17-2.63-7.37 4.22-2.54 7.17 2.19z"
  /><path
    fill="#f5821f"
    opacity=".2"
    d="M797.45 376.5l2.67 35.92h-1.87l-10.7-29.97 9.9-5.95z"
  /><path
    opacity=".1"
    d="M802.07 366.45l-4.62 7.16-13.99 6.7 18.61-13.86zM804.38 410.7l-.54 1.72h-5.58l-.42-1.17a4.68 4.68 0 013.58-1.34 5.36 5.36 0 012.96.79zM801.94 413.01v3.06h-.52a6.15 6.15 0 01-1.46-.17v-2.93z"
  /><ellipse
    cx="801.42"
    cy="413.01"
    rx="3.97"
    ry="2.36"
    fill="#dce2ed"
  /><ellipse
    cx="445"
    cy="790.15"
    rx="445"
    ry="44"
    fill="#f5821f"
    opacity=".1"
  /><path
    d="M446.84 687.76s-89.2-3.75-98.59-178.4 83.57-204.23 83.57-204.23 29.45-16.45 42.51-17.13 56.71 3.43 56.71 3.43l-48.12-9.28s67.71-25.77 88-27.83l-73.2 15.46s-1-40.55 16.5-53.95c0 0-15-1.12-22.91 28.09a55.8 55.8 0 01-33.42 37.5c-27.15 10.59-64.69 27.31-73.24 41.63 0 0-15.81 16.5-13.4-26.46s13.74-79.74 17.87-80.77c0 0 32.3-34.36 77.67-36.42 0 0-26.46-10.66-71.14 22.68 0 0-3.78-16.84 13.06-36.78s43-61.86 71.48-66.32c0 0-39.86-2.41-71.48 49.14 0 0-11.69 7.56-12.72-11.68s-7.9-43.31-7.9-43.31-9.63 44.34 10.65 64.27c0 0-38.84 50.52-37.12 107.23 0 0-12 25.77-16.49-4.47 0 0-2.59-41.65-7.76-77a104.62 104.62 0 0121.94-80.71c8.59-10.69 14.57-21.07 11.25-26.52l-45 53.61s-37.85-87.61-65.34-106.47-30.93-23-30.93-23l44.33 51.89-55.67-19.66 55.67 25.77s25.78 21 40.56 78.36 16.15 93.13 16.15 93.13-79.39-62.89-94.51-60.83l51.37 38.86a122.37 122.37 0 0148.29 89.33s-99.32-25.43-123.38-30.24l-45.36-46.4 34.37 44-70.8-1-40.55-28.87s32 26.81 28.86 28.53-49.83 3.78-49.83 3.78 118.91-.69 132 7.9 42.27 11.69 42.27 11.69l-84.2 12.71 100.36-7.21s75.95 13.74 80.07 37.46c0 0-15.47 40.36-25.77 56.36-8.56 13.3-25.78 56.36-29.21 94.17s-8.25 95.88 4.81 131.28 17.87 55.68 11.34 66.33-12.72 24.4 8.59 27.15 114.79-1.37 114.79-1.37 28.51 5.6 23-15.43z"
    fill="#dea3a2"
  /><path
    d="M396.88 669.01a44.9 44.9 0 00-30.31-3.79c-17.5 3.79-44.31 1.78-46.75 1.36M340.89 463.21s-4.26 67.18 3.31 80.43zM325.17 543.64s5.46 62.92 9.24 75.22-9.24-75.22-9.24-75.22zM319.85 388.93c-3.87 1.42-20.43 35-17.11 44.95s17.11-44.95 17.11-44.95zM361.83 354.07c-1.79.81-9.5 20.16-8 25.88s8-25.88 8-25.88zM290.13 466.88c1.92 19.51 3 32.28 1.74 47.9a184.7 184.7 0 00.52 36.43M497.47 239.73c-2.33 2.66-3.11 6.35-3.22 9.89s.34 7.08.11 10.61c-.25 3.71-2 8.07-5.7 8.56M434.01 123.42a89.35 89.35 0 00-12.44 15.44 36.81 36.81 0 01-3.53 5c-2 2.18-4.54 3.73-6.82 5.59a32.1 32.1 0 00-10.87 17M254.35 23a22.21 22.21 0 004.41 5.9c1.56 1.48 3.34 2.74 4.75 4.36a34.56 34.56 0 013 4.48c3.62 5.79 8.17 10.94 12.71 16M337.57 122.42c-3 1.85-3.73 5.81-3.67 9.3s.66 7.13-.63 10.37c-.59 1.48-1.55 2.78-2.17 4.24-1.06 2.52-1.06 5.34-1 8.08.05 3.16.15 6.33.29 9.49.16 3.8.52 7.94 3.11 10.73"
    opacity=".1"
  /><path
    d="M312.66 221.07a40.94 40.94 0 017.71 5.31 13.84 13.84 0 014.48 8c.17 1.33.08 2.69.38 4a12.62 12.62 0 002.63 4.83 66.42 66.42 0 006.51 7.21"
    fill="none"
  /><path
    d="M335.1 310.75a46.94 46.94 0 00-6.22-4.32 25.84 25.84 0 00-6.39-2.81c-3.43-.91-7-.77-10.56-1.14s-7.22-1.35-9.62-4M195.36 267.33c4.18.12 8.52.27 12.24 2.18 1.9 1 3.55 2.38 5.41 3.42a16.36 16.36 0 007.89 2.05M253.34 284.59c-.9-.7-2.26-.16-3 .7s-1.15 2-1.92 2.8c-1.53 1.65-4 1.84-6.27 1.92M277.25 195.76l4 2.11a71.08 71.08 0 0111.87 7.2M323.17 235.07c2.64-.63 4.92 2.19 5.39 4.86s-.08 5.49.67 8.1a15.11 15.11 0 004 5.93M367.87 239.96c2.41 7.18-2.69 15-1.2 22.43.45 2.26 1.5 4.36 2 6.61 1.39 5.9-1 12.18-4.86 16.87"
    opacity=".1"
  /><path
    fill="#535f89"
    d="M217.24 181.71h6.95v383.28h-6.95z"
  /><path
    d="M230.79 636.68a18.12 18.12 0 01-22.25 0c-3.1-20.51 4.78-60.82 6.64-69.86l.39-1.83h8.9a6.59 6.59 0 011.39 2.08c6.16 13.12 4.93 69.61 4.93 69.61z"
    fill="#535f89"
  /><path
    d="M222.64 556.71v8.28h-3.75v-8.29a10.86 10.86 0 011.83-.14 12 12 0 011.92.15zM225.86 567.07a10.64 10.64 0 01-5.14 1.21 10.26 10.26 0 01-5.54-1.46l.39-1.83h8.9a6.59 6.59 0 011.39 2.08z"
    opacity=".1"
  /><ellipse
    cx="220.72"
    cy="562.42"
    rx="7.5"
    ry="4.45"
    fill="#dce2ed"
  /><path
    fill="#f5821f"
    d="M187.74 119.97l26.42-12.65 38.95 9.31-30.23-22.84-35.14 26.18z"
  /><path
    fill="#f5821f"
    d="M195.47 124.01l-7.73-4.04 26.42-12.65 38.95 9.31-6.86 3.34-32.09-7.2-18.69 11.24z"
  /><path
    opacity=".1"
    d="M195.47 124.01l-7.73-4.04 26.42-12.65 38.95 9.31-6.86 3.34-32.09-7.2-18.69 11.24z"
  /><path
    fill="#f5821f"
    opacity=".2"
    d="M194.42 121.03l21.26 59.56h10.54l19.68-63.25-31.74-7.38-19.74 11.07z"
  /><path
    fill="#f5821f"
    d="M231.44 163.83l-4.21 13.51-1.01 3.26h-10.54l-.79-2.21-4.96-13.91 7.97-4.8 13.54 4.15z"
  /><path
    fill="#f5821f"
    opacity=".2"
    d="M214.16 112.77l5.03 67.82h-3.51l-20.21-56.58 18.69-11.24z"
  /><path
    opacity=".1"
    d="M222.88 93.79l-8.72 13.53-26.42 12.65 35.14-26.18zM227.24 177.34l-1 3.26h-10.56l-.78-2.21c1.19-1.5 3.76-2.54 6.76-2.54a10.19 10.19 0 015.58 1.49zM222.64 181.71v5.8c-.32 0-.65.05-1 .05a11.62 11.62 0 01-2.77-.33v-5.52z"
  /><ellipse
    cx="221.65"
    cy="181.71"
    rx="7.5"
    ry="4.45"
    fill="#dce2ed"
  /><ellipse
    cx="914.02"
    cy="687.72"
    rx="16.82"
    ry="2.84"
    fill="#f5821f"
    opacity=".1"
  /><path
    d="M902.73 674.51s9.59-.3 12.48-2.36 14.76-4.51 15.47-1.21 14.42 16.42 3.59 16.51-25.17-1.69-28.05-3.45-3.49-9.49-3.49-9.49z"
    fill="#a8a8a8"
  /><path
    d="M934.46 686.3c-10.83.09-25.16-1.69-28-3.45-2.19-1.34-3.07-6.14-3.36-8.35h-.32s.6 7.73 3.49 9.49 17.22 3.53 28.05 3.45c3.13 0 4.2-1.14 4.15-2.79-.49 1.01-1.68 1.63-4.01 1.65z"
    opacity=".2"
  /><ellipse
    cx="1011.56"
    cy="654.6"
    rx="12.94"
    ry="2.19"
    fill="#f5821f"
    opacity=".1"
  /><path
    d="M1002.87 644.43s7.38-.23 9.61-1.81 11.35-3.48 11.9-.94 11.1 12.64 2.76 12.7-19.36-1.29-21.58-2.65-2.69-7.3-2.69-7.3z"
    fill="#a8a8a8"
  /><path
    d="M1027.29 653.5c-8.33.07-19.36-1.3-21.58-2.65-1.69-1-2.37-4.73-2.59-6.43h-.25s.47 5.95 2.69 7.3 13.25 2.72 21.58 2.65c2.41 0 3.24-.87 3.19-2.14-.33.78-1.25 1.26-3.04 1.27z"
    opacity=".2"
  /><ellipse
    cx="952.84"
    cy="792.9"
    rx="30.89"
    ry="5.22"
    fill="#f5821f"
    opacity=".1"
  /><path
    d="M932.1 768.63s17.62-.55 22.93-4.33 27.11-8.3 28.43-2.23 26.48 30.16 6.58 30.32-46.22-3.09-51.47-6.32-6.47-17.44-6.47-17.44z"
    fill="#a8a8a8"
  /><path
    d="M990.4 790.28c-19.9.16-46.23-3.1-51.53-6.32-4-2.46-5.64-11.29-6.18-15.36h-.59s1.12 14.24 6.47 17.47 31.63 6.49 51.52 6.32c5.75 0 7.73-2.08 7.62-5.11-.85 1.79-3.04 2.97-7.31 3z"
    opacity=".2"
  /><path
    d="M634.09 547.3s51.23-2.16 56.62-102.46-48-117.3-48-117.3-16.91-9.45-24.41-9.84-32.57 2-32.57 2l27.63-5.33s-38.88-14.8-50.53-16l42 8.88s.59-23.29-9.48-31c0 0 8.58-.64 13.16 16.13a32 32 0 0019.19 21.54c15.6 6.09 37.16 15.69 42.07 23.91 0 0 9.08 9.48 7.69-15.2s-7.89-45.8-10.26-46.39c0 0-18.55-19.73-44.61-20.92 0 0 15.2-6.11 40.86 13 0 0 2.17-9.67-7.5-21.12s-24.67-35.53-41.06-38.09c0 0 22.9-1.39 41.06 28.22 0 0 6.71 4.34 7.3-6.71s4.54-24.87 4.54-24.87 5.53 25.46-6.12 36.91c0 0 22.31 29 21.32 61.59 0 0 6.91 14.8 9.48-2.57 0 0 1.48-23.92 4.45-44.21a60.13 60.13 0 00-12.6-46.36c-4.93-6.13-8.37-12.1-6.46-15.23l25.86 30.79s21.71-50.33 37.5-61.19 17.77-13.22 17.77-13.22l-25.42 29.81 32-11.25-32 14.81s-14.8 12-23.29 45-9.28 53.49-9.28 53.49 45.57-36.05 54.29-34.91l-29.51 22.31a70.31 70.31 0 00-27.74 51.31s57-14.61 70.87-17.37l26-26.65-19.69 25.26 40.66-.59 23.3-16.58s-18.36 15.4-16.61 16.39 28.63 2.17 28.63 2.17-68.3-.39-75.8 4.54-24.28 6.71-24.28 6.71l48.38 7.36-57.64-4.15s-43.62 7.9-46 21.52c0 0 8.89 23.18 14.81 32.37 4.91 7.63 14.8 32.37 16.77 54.08s4.74 55.07-2.76 75.4-10.26 32-6.51 38.1 7.3 14-4.94 15.59-65.93-.79-65.93-.79-16.38 3.19-13.21-8.89z"
    fill="#dea3a2"
  /><path
    d="M662.78 536.53a25.76 25.76 0 0117.39-2.17c10 2.17 25.45 1 26.85.78M694.94 418.33s2.44 38.59-1.9 46.19zM703.96 464.52s-3.13 36.14-5.3 43.21 5.3-43.21 5.3-43.21zM707.02 375.67c2.22.82 11.73 20.11 9.83 25.81s-9.83-25.81-9.83-25.81zM682.91 355.65c1 .46 5.46 11.58 4.57 14.86s-4.57-14.86-4.57-14.86zM724.09 420.44c-1.1 11.21-1.7 18.54-1 27.51a105.41 105.41 0 01-.3 20.92M605 289.98a9 9 0 011.86 5.68c.07 2-.2 4.06-.07 6.09s1.16 4.63 3.28 4.92M641.46 223.17a51.22 51.22 0 017.11 8.9 20.84 20.84 0 002 2.89 33 33 0 003.92 3.21 18.46 18.46 0 016.24 9.79M744.64 165.5a12.94 12.94 0 01-2.53 3.39c-.9.85-1.92 1.57-2.73 2.5a19.71 19.71 0 00-1.75 2.57 69.5 69.5 0 01-7.29 9.22M696.85 222.6c1.71 1.06 2.15 3.34 2.11 5.34s-.38 4.1.37 6c.34.85.89 1.6 1.24 2.44a11.44 11.44 0 01.59 4.63c0 1.82-.09 3.64-.17 5.45-.09 2.19-.3 4.56-1.78 6.17"
    opacity=".1"
  /><path
    d="M711.15 279.23a23.72 23.72 0 00-4.43 3 7.94 7.94 0 00-2.57 4.62c-.1.76-.05 1.54-.22 2.29a7.3 7.3 0 01-1.51 2.77 37.58 37.58 0 01-3.74 4.14"
    fill="none"
  /><path
    d="M698.26 330.77a28.1 28.1 0 013.57-2.48 15.1 15.1 0 013.68-1.62 39.55 39.55 0 016.06-.6 8.59 8.59 0 005.53-2.27M778.57 305.83c-2.4.07-4.89.15-7 1.25-1.09.56-2 1.37-3.11 2a9.33 9.33 0 01-4.53 1.18M745.22 315.74a1.35 1.35 0 011.73.4c.43.49.66 1.13 1.11 1.61.87.95 2.3 1.06 3.59 1.1M731.49 264.73l-2.31 1.2a40.93 40.93 0 00-6.8 4.15M705.12 287.29c-1.52-.36-2.83 1.26-3.1 2.8s0 3.15-.39 4.65a8.7 8.7 0 01-2.27 3.41M679.44 290.07c-1.38 4.12 1.55 8.62.69 12.88-.26 1.3-.86 2.51-1.17 3.8-.8 3.39.58 7 2.79 9.69"
    opacity=".1"
  /><path
    d="M381.09 372.79c-16.42 22.14-29.94 87.27-33.73 106.9l-28.6-1.13c1.8-16.89 36.38-85.09 46-103.8 5.15-.69 10.66-1.39 16.33-1.97z"
    fill="#f5821f"
  /><path
    fill="#dce0ed"
    d="M725.73 364.93h12.68v17.86h-12.68z"
  /><path
    d="M738.41 364.93v5.81a9.76 9.76 0 01-2.75.37l-9.92-.08v-6.1z"
    opacity=".1"
  /><path
    d="M720.38 319.43h12a14.37 14.37 0 0113.31 9c3.5 8.63 6.47 22.35-1.33 36a9.88 9.88 0 01-8.67 5l-15.28-.13z"
    fill="#dce0ed"
  /><ellipse
    cx="720.38"
    cy="344.37"
    rx="12.82"
    ry="24.93"
    fill="#f0f0f4"
  /><path
    fill="#dce0ed"
    d="M613.13 365.14h12.68v15.63h-12.68z"
  /><path
    d="M625.81 365.14v5a9.78 9.78 0 01-2.76.37l-9.92-.09v-5.25z"
    opacity=".1"
  /><path
    d="M607.78 319.65h12a14.34 14.34 0 0113.3 9c3.51 8.63 6.48 22.35-1.32 36a9.9 9.9 0 01-8.68 5l-15.27-.14z"
    fill="#dce0ed"
  /><ellipse
    cx="607.78"
    cy="344.58"
    rx="12.82"
    ry="24.93"
    fill="#f0f0f4"
  /><path
    d="M610.98 328.76s-4.73.76-2.27 7a42.66 42.66 0 012.83 9.45s4.73 2.46 4.54-5.67-5.1-10.78-5.1-10.78z"
    fill="#dce0ed"
  /><ellipse
    cx="130.6"
    cy="685"
    rx="74.79"
    ry="81.97"
    fill="#636780"
  /><path
    d="M158.62 608.14c-39.13 2.63-70.13 38.25-70.13 81.81 0 35.11 20.14 65.06 48.45 76.73 39.14-2.63 70.14-38.25 70.14-81.81 0-35.11-20.15-65.06-48.46-76.73z"
    opacity=".1"
  /><ellipse
    cx="715.94"
    cy="505.84"
    rx="60.7"
    ry="79.15"
    fill="#636780"
  /><path
    d="M698.98 430c-25.18 9.65-43.56 40-43.56 75.95 0 38.42 21 70.44 48.84 77.64 25.17-9.65 43.56-40 43.56-75.95 0-38.42-21-70.44-48.84-77.64z"
    opacity=".1"
  /><path
    d="M487.92 488.94l1.13-28.73s-5.64-12.4-11.27-13.52-18.59-1.83-18.59-1.83-10.14 41.26-3.38 53.66 32.11-9.58 32.11-9.58z"
    fill="#f5821f"
  /><path
    d="M487.92 488.94l1.13-28.73s-5.64-12.4-11.27-13.52-18.59-1.83-18.59-1.83-10.14 41.26-3.38 53.66 32.11-9.58 32.11-9.58z"
    opacity=".1"
  /><path
    d="M383.98 485.84s-3.49-39.84 18.4-40.56c2.82-.09 5.64-.16 8.45-.43 15.17-1.47 56.56-4.66 51.6 4.79 0 0-9.86 34.65-3.1 43.38zM694.26 559.71l29.36.85s5.07-54.09 6.76-58.31 2.54-24.51-2.95-27.46-23.86-6.55-23.86-6.55l-13.54 30.83-1.05 27.89z"
    fill="#f5821f"
  /><path
    d="M694.26 559.71l29.36.85s5.07-54.09 6.76-58.31 2.54-24.51-2.95-27.46-23.86-6.55-23.86-6.55l-13.54 30.83-1.05 27.89z"
    opacity=".1"
  /><path
    d="M623.27 469.93l-.13-6a3.47 3.47 0 013.62-3.54c14.56.61 67.52 3.15 76.79 7.88 0 0-10.14 75.42 1.06 93.38l-3.8 60.42-129.72-9.72z"
    fill="#f5821f"
  /><path
    d="M613.13 374.68c3.6-.36 7.89-.74 12.68-1.12v7.21h-12.68zM738.41 381.87v.91h-12.67v-5.48a54.13 54.13 0 0112.67 4.57z"
    opacity=".1"
  /><path
    d="M429.46 503.18a1.18 1.18 0 01.48-.75 1.69 1.69 0 01.87-.08v.51a19.56 19.56 0 00-1.81 1.85c.18-.51.31-1.02.46-1.53zm45.89-13.46a1.55 1.55 0 000-.21 44.29 44.29 0 012.19-4.68c-.8 1.54-1.54 3.17-2.19 4.89zm6.84-12.94a72.01 72.01 0 00-3.68 6.1 28.34 28.34 0 013.68-6.1zM303.52 616.72c5.09.2 9.33.11 9.33.11-.92.42-5.01.23-9.33-.11zm9.34.1c.19-.12 2.07-1.22 6.46-.78 0-.04-4.32-.19-6.46.78zm170.81-76.92l1.86-32s-.69 16.34-.46 23.41a23 23 0 01-1.4 8.6z"
    transform="translate(-48.43 -32.93)"
    fill="url(#a)"
  /><path
    d="M328.82 568.25s-.53 1.64-1.23 3.72c-1.14 3.39-2.75 8-3.3 8.43s-4.81.71-9.45 1a29.22 29.22 0 01-19.92-6.33s2.43-1.75 5-3.78 5.27-4.33 5.82-5.46c.77-1.55 5.17-4.22 7.82-5.72 1.19-.68 2-1.12 2-1.12z"
    fill="#f899a5"
  /><path
    d="M323.2 582.38s-46.76-2.15-49.55-2.77-3.36-3.9-3.36-3.9c-.93-2.18 4-1.71 4-1.71.5.08 6 1 11.18 1.66 4.15.53 8.08.89 9 .5 2.09-.87 6.26-.5 6.26-.5-2.37-7.84-9.55-9.71-12.62-10.15l.19-.19a15.7 15.7 0 012.67-2c9.53.39 14.57 13.53 14.57 13.53h.08c1.08.34 12.57 3.9 14.85 4.23 2.38.37 2.73 1.3 2.73 1.3z"
    fill="#f3b4b4"
  /><path
    d="M298.75 586.55c-.18.59-1 1-2.34 1.11a15.2 15.2 0 01-2.18 0 49.52 49.52 0 01-13-2.92c-.72-.25-1.4-.47-2.06-.66h-.08a28.33 28.33 0 00-4.86-1c-4.24-.44-6.05.66-6.23.78s-4.1.09-9-.11a73.14 73.14 0 01-11.23-1.18c-.53-.11-1-.24-1.49-.37a10.4 10.4 0 01-2.51-1c-5.16-3.1 12.22-5.19 12.22-5.19a9.06 9.06 0 005.26-2.54l.18-.2.44-.44a23.9 23.9 0 012.11-1.64l.64-.43c3.46-2.34 8.12-4.84 8.12-4.84a19.74 19.74 0 008.61-4.92 10.21 10.21 0 001.2-1.42l9.61-2.48 6.62 15.9s.05.86.1 2.15c.11 3.46.3 10-.13 11.4z"
    fill="#f899a5"
  /><path
    d="M296.41 587.66a15.2 15.2 0 01-2.18 0 49.52 49.52 0 01-13-2.92c-.72-.25-1.4-.47-2.06-.66h-.08a28.33 28.33 0 00-4.86-1c-4.24-.44-6.05.66-6.23.78s-4.1.09-9-.11a73.14 73.14 0 01-11.23-1.18c-.53-.11-1-.24-1.49-.37a11.91 11.91 0 011.93-.08c.49.06 6.05.74 11.23 1.17 4.18.35 8.12.54 9 .11 2.05-1 6.23-.78 6.23-.78-2.7-7.73-10-9.28-13.05-9.59.06-.07.13-.13.18-.2a16.51 16.51 0 012.55-2.08h.2c9.41.15 14.95 12.87 14.95 12.87h.08c1.09.29 12.73 3.36 15 3.59a5.73 5.73 0 011.83.45z"
    opacity=".1"
  /><path
    d="M296.96 588.85s-46.81-.12-49.62-.61-3.53-3.76-3.53-3.76c-1-2.13 3.89-1.87 3.89-1.87.49.06 6 .74 11.23 1.18 4.17.34 8.12.53 9 .11 2-1 6.23-.78 6.23-.78-2.71-7.73-10-9.28-13.05-9.59l.18-.2a17.09 17.09 0 012.58-2.11c9.54 0 15.15 12.88 15.15 12.88h.08c1.09.28 12.73 3.35 15 3.58 2.47.25 2.86 1.17 2.86 1.17z"
    fill="#f3b4b4"
  /><path
    d="M328.82 568.25s-.53 1.64-1.23 3.72c-.28-.19-9.49-6.32-13-10.34a7.61 7.61 0 01-1.06-1.49c1.19-.68 2-1.12 2-1.12z"
    opacity=".1"
  /><path
    d="M355.76 547.97l-1.66 5.37-15.9 8.66s-4.3 3.05-5 4.49a4.48 4.48 0 01-2.54 2 35.24 35.24 0 00-2.2 3.06s-9.44-6.26-13-10.34c-1.1-1.26-1.63-2.32-1.13-2.91 2.08-2.5 14.56-11.48 14.56-11.48s7.62-10 7.95-9.82 4.16-3.51 6.41-5.6l1.54-1.44z"
    fill="#bdd3e8"
  /><path
    d="M431.57 439.86l-15.48 27.38-5.68 10.83-30.25-4.41.68-1.45 2.56-5.37 1.17-2.46.18-.33 3.35-6.07.19-.25 2.43-3.44 4.89-6.91a4.42 4.42 0 001.6-.42 3.78 3.78 0 001.83-2.08c1.73-4.28-1.44-12.51-1.44-12.51s11.48-28 15.46-12.59c2.94 11.43 11.67 16.95 16 19a22 22 0 002.51 1.08z"
    fill="#f899a5"
  /><path
    d="M379.57 533.99v2.65s10 9.57 8.68 17.37 1.47 17.52 1.47 17.52l10.06-.72-1.52-35.64z"
    fill="#bdd3e8"
  /><path
    d="M399.78 570.81l-10.06.72s-2.79-9.71-1.47-17.52-8.68-17.37-8.68-17.37v-2.65l18.69 1.18.1 2.32zM344.08 532.96a84 84 0 00-8.82 9.57c-3.54 4.71-9.57 11.48-9.57 11.48l-7.21 4.27-3 2.91c-1.1-1.26-1.63-2.32-1.13-2.91 2.08-2.5 14.56-11.48 14.56-11.48s7.62-10 7.95-9.82 4.16-3.51 6.41-5.6z"
    opacity=".05"
  /><path
    d="M298.85 575.15a9.73 9.73 0 00-.83.8s-.15 4.7-3.83-6.34-12.81-8.39-12.81-8.39a.17.17 0 01-.07-.2c0-.3.53-.82 1.2-1.42l9.61-2.48 6.62 15.9s.06.84.11 2.13z"
    opacity=".1"
  /><path
    d="M332.76 512.35l-5.6.15-3.83 5.45s-6.33 6.77-8.24 8.46-14.28 13.32-17.81 19.36c0 0-3.24 1.62-3.24 3.24s-6.18 6.33-6.18 6.33-6.48 4.41-5.6 5c0 0 9.13-2.65 12.81 8.39s3.83 6.33 3.83 6.33a8.59 8.59 0 012.21-1.74c.88-.32 5.07-6.35 6.36-6.5a6.36 6.36 0 002.62-1.18l7.5-7.36 7.22-4.27s6-6.77 9.56-11.48a84.69 84.69 0 018.83-9.57z"
    fill="#bdd3e8"
  /><path
    d="M304.79 547.98s10 4.85 9.57 5.88-9.57-5.88-9.57-5.88zM312.69 546.8s.78 4.37 4.76 4.17-4.76-4.17-4.76-4.17zM298.75 559.07s.59 2.5 4.27 2.94-4.27-2.94-4.27-2.94zM336.22 547.98s4.85 2 5.29 4.78-5.29-4.78-5.29-4.78zM324.29 558.28c1.88.81 7.29 6.88 7.18 7.54s-7.18-7.54-7.18-7.54zM332.9 553.97a3.25 3.25 0 013.32.7c1.35 1.4-3.32-.7-3.32-.7z"
    opacity=".1"
  /><path
    d="M368.57 505.88s-18.77-6.08-17.33 0 17.33 9.49 17.33 9.49z"
    fill="#f899a5"
  /><path
    d="M431.57 439.86l-15.48 27.38-5.68 10.83-30.25-4.41.68-1.45a17.46 17.46 0 012.41-2.7 10 10 0 01.15-2.67 5.19 5.19 0 011.35-2.79l.12-.11c1.42-1.25 2.77-4.48 3.42-6.21.26-.69.4-1.15.4-1.15l2-2.29 6.49-7.33 1.83-2.08 1.72-1.94-6.16 8.76s-2.94 5.3-3.09 6-5 7.21-5 7.21-8.24 7.22 6.48 7.36 23.7-14.2 23.7-14.2l12.42-19.24a22 22 0 002.49 1.03zM398.36 537.49l-5.77-.4-13.03-1.09v-2l18.7 1.17.1 2.32z"
    opacity=".1"
  /><path
    d="M429.03 437.28s2.65 2.94 5.3 3.09c0 0-4.86 5.15-6.63 10.16 0 0-8.26 13.9-2.35 18.69s9.34 5.74 9.34 5.74l-1.79 32s4.37 22 6 23.64 1.18 5.3 1.18 5.3-1.07 3.68.05 5 1.42 8.1 1.42 8.1-6.62-3.39-8-3.39-5-6.92-5-6.92l-36-2.5-15.83-1.32 2.5-44s-7.21-11.83 2.65-20.93c0 0-.38-3.81 1.62-5.57s3.83-7.36 3.83-7.36l12.07-13.64-6.18 8.79s-2.95 5.3-3.09 6-5 7.22-5 7.22-8.24 7.21 6.48 7.36 23.7-14.28 23.7-14.28z"
    fill="#e6ebef"
  /><path
    d="M417.25 495.28s5.12 3.75 10.6 3.9-10.6-3.9-10.6-3.9zM423.87 483.39s4.05-2 6.33-.33-6.33.33-6.33.33zM421.96 490.07s.26 2.36 6.26 2.65-6.26-2.65-6.26-2.65z"
    opacity=".1"
  /><path
    d="M433.88 440.37l1.26.67a28.1 28.1 0 007.94 1.69c5.08.44 9.5 5.3 10.38 9.93.22 1.16.4 2.71.55 4.37a89.74 89.74 0 01-.28 18c-.48 4.23-1 9-.71 9.7.44 1.32-2.43 21.86-2.43 21.86s-.66 16.78-4.86 18.33-27.6 1.54-27.6 1.54l-9.93-17.22 23.18 1.1a22.68 22.68 0 002.87-11.92c-.22-7.07.44-23.41.44-23.41s-14-3-11.16-13.93 10.35-20.71 10.35-20.71z"
    fill="#f899a5"
  /><path
    d="M389.72 571.53s-9.35 3.09-13 1.47-11.59-7.8-11.59-7.8-5.1-5-9.95-10.59l-.62-.72c-4.2-4.89-8-10-8-12.53a10.65 10.65 0 00-.39-3.11 13 13 0 00-2-4.07 12.15 12.15 0 00-1.72-1.94l-15.31-19.73s4.42-4.71 4.42-6 5.3-8.53 12.07-4.7c2.85 1.6 9.66 7.57 16.6 13.94 9.55 8.76 19.32 18.29 19.32 18.29s.69.74 1.7 1.89c2.59 3 7.27 8.65 7.64 11.51.54 3.92.83 24.09.83 24.09z"
    fill="#bdd3e8"
  /><path
    d="M381.27 535.88c-7.25 7.22-18.16 16.9-26.08 18.73l-.21.05-.41-.77-8.36-15.64-2.12-4 .11-.11 16.06-18.47c9.55 8.76 19.32 18.29 19.32 18.29s.68.77 1.69 1.92z"
    opacity=".05"
  /><path
    d="M439.88 549.41v3.35s4.64 16.38-3.75 21c-4.24 2.35-13.27 2.91-21.17 2.89a22.42 22.42 0 01-22.13-18.45 13.4 13.4 0 01-.09-4.75s-3.75-26.83-4.64-27c0 0-21.09 24.15-34 26.93L343.2 533l17.41-20s12.92-20.53 16.67-22.41 7.51-7.14 7.51-7.14 15.13-12.62 25.17 8.69 16.56 38.52 19 44.91c0 0 3.54 7.24 5.74 7.22h.07a5.16 5.16 0 015.11 5.14z"
    fill="#bdd3e8"
  /><path
    d="M387.66 525.31a21.82 21.82 0 004.52-7.73c1.67-4.86-.5 4.93-4.08 8.83z"
    opacity=".1"
  /><path
    d="M368.01 403.8c.15 1.4 1.2 2.65 2.28 3.82a73 73 0 007.38 6.95c1.12.93 2.33 1.9 2.7 3.11a4.89 4.89 0 01-.18 2.7 46.29 46.29 0 01-3.92 9.74 6 6 0 00-1.09 3.32c.27 2.62 4 4.09 6.72 5.82 3.57 2.31 5.63 5.8 5.5 9.28-.22 5.43-5.37 10.12-6.58 15.48a26 26 0 009.73-2c2.86-1.35 5-3.7 4.88-6.2a1.75 1.75 0 01.15-1.15 2.47 2.47 0 011.4-.72c2.67-.65 5.93-.44 7.89-1.93s1.51-4.11.67-6.2c-2.28-5.72-5.58-11.22-7.57-17a12.2 12.2 0 01-.86-6.08c.36-2 1.59-3.91 2.64-5.81a37 37 0 004.38-13.34c.32-2.64.31-5.39-1.08-7.83-1.55-2.75-4.84-4.93-8.73-5.78-7.51-1.65-11.51 2-17.38 4.43-4.37 1.86-9.37 5.19-8.93 9.39z"
    fill="#4b3648"
  /><path
    d="M380.82 463.57c.61 0 1.22-.07 1.83-.12 1.25-5.31 6.32-10 6.54-15.35.13-3.48-1.94-7-5.5-9.29-2.68-1.73-6.45-3.2-6.72-5.81a6.05 6.05 0 011.09-3.33 46.29 46.29 0 003.92-9.74 4.89 4.89 0 00.18-2.7c-.37-1.21-1.58-2.18-2.7-3.1a74.27 74.27 0 01-7.38-7c-1.08-1.16-2.13-2.41-2.28-3.81-.46-4.2 4.51-7.54 8.93-9.39 4.59-1.94 8-4.56 12.94-4.82-5.88-.38-9.59 2.66-14.73 4.82-4.42 1.85-9.39 5.19-8.93 9.39.15 1.4 1.2 2.65 2.28 3.81a74.27 74.27 0 007.38 7c1.12.92 2.33 1.89 2.7 3.1a4.89 4.89 0 01-.18 2.7 46.29 46.29 0 01-3.92 9.74 6.05 6.05 0 00-1.09 3.33c.27 2.61 4 4.08 6.72 5.81 3.57 2.31 5.63 5.81 5.5 9.29-.22 5.42-5.37 10.12-6.58 15.47z"
    opacity=".1"
  /><circle
    cx="397.67"
    cy="415.42"
    r="23.52"
    opacity=".1"
  /><circle
    cx="398.11"
    cy="414.54"
    r="23.52"
    fill="#f899a5"
  /><path
    d="M383.63 403.51c-1.84-.58-3.77-1.22-5-2.85s-1.45-4.57.12-5.91a10.34 10.34 0 012.83-1.23c3.95-1.75 4.62-7.88 7.3-11.71a8.78 8.78 0 018.1-3.9 39 39 0 014.89 1.44c3.91 1.06 8.09.22 12.06.94 7.8 1.43 13.77 8.77 17 17 1.49 3.79 2.53 7.8 3.71 11.75a155.64 155.64 0 006.4 17.4 12.23 12.23 0 002.19 3.69c2.5 2.55 6.92 2.36 8.46 5.79.85 1.9.45 4.23.17 6.38a50.76 50.76 0 001.84 21.63c1.69 5.36 4.92 10.78 9.85 11.55-1.89 2.64-5.59 2.39-7.93.5s-3.74-4.93-5.31-7.7a49 49 0 00-4.53-6.65 9.35 9.35 0 00-3.43-2.95c-3.36-1.36-6.93 1.42-9.93 3.84-2.47 2-5.14 3.87-8.09 4.25a6.5 6.5 0 01-7.15-4.39c-1.13-3.83 1.15-9-1.34-11.78-.9-1-2.22-1.37-3.3-2.14-3.18-2.26-3.57-7.43-3.14-11.81s1.33-9.08-.37-12.93a15.57 15.57 0 00-4-5 88 88 0 00-24.16-15.86"
    fill="#4b3648"
  /><g opacity=".1"><path d="M426.86 466.07a6.5 6.5 0 01-7.16-4.39c-1.13-3.82 1.16-9-1.34-11.78-.9-1-2.22-1.37-3.29-2.13-3.19-2.26-3.58-7.43-3.14-11.81s1.33-9.09-.38-12.94a15.68 15.68 0 00-4-5 88 88 0 00-24.16-15.95l2.78.66c-1.84-.58-3.78-1.23-5-2.85s-1.45-4.57.13-5.92a10.26 10.26 0 012.82-1.22c4-1.75 4.62-7.88 7.3-11.71a9.66 9.66 0 013.37-3 9.19 9.19 0 00-6.05 3.87c-2.68 3.83-3.34 10-7.3 11.71a10.34 10.34 0 00-2.83 1.23c-1.57 1.34-1.38 4.29-.12 5.91s3.2 2.27 5 2.85l-2.77-.65a88 88 0 0124.15 15.92 15.57 15.57 0 014 5c1.71 3.85.81 8.55.37 12.93s0 9.55 3.14 11.81c1.08.77 2.4 1.12 3.3 2.14 2.49 2.79.21 7.95 1.34 11.78a6.5 6.5 0 007.15 4.39 10.38 10.38 0 003.22-1 4.94 4.94 0 01-.53.15zM458.14 475.23c-2.34-1.89-3.74-4.93-5.3-7.69a47.52 47.52 0 00-4.54-6.65 9.18 9.18 0 00-3.43-2.95 6.2 6.2 0 00-5.26.58 5.09 5.09 0 012.58.31 9.27 9.27 0 013.43 2.95 49 49 0 014.53 6.65c1.57 2.77 3 5.81 5.31 7.7 2 1.58 4.88 2 6.89.55a6.49 6.49 0 01-4.21-1.45z" /></g><path
    fill="#dce0ed"
    d="M802 561.62l-19.16.28-39.58-71.93-6.61-12.01 5.07-30.42 3.9 7.36L802 561.62zM628.76 473.17L620.88 485l-23.58-31.88-10.79-14.6 6.48-8.73 4.96 6.02 30.81 37.36z"
  /><path
    d="M597.95 435.8c0 .61.07 1.24.11 1.87l-.76 15.45-10.79-14.6 6.48-8.73zM745.62 454.9l-2.36 35.07-6.61-12.01 5.07-30.42 3.9 7.36z"
    opacity=".1"
  /><path
    d="M575.57 458.24s-9.46-70.65 25-81.22a8.74 8.74 0 011.35-.28c7.93-.95 81.8-9.47 120.15.65 0 0 26.2 3.95 25.92 18l-11.62 172.14H717.5l6.19-113.8s9-49.58-5.91-53-82.82-9-106.76-2.25c0 0-17.47-3.95-14.65 39.15l-1.13 23.1z"
    fill="#dce0ed"
  /><path
    d="M632.99 479.22a10.88 10.88 0 00-4.44-9.72c-5.28-4-21.55-12.67-21.55-12.67l-5.28.42-15.84 39.3 1.05 83.45 28.52 35.28z"
    fill="#f5821f"
  /><path
    d="M632.99 479.22a10.88 10.88 0 00-4.44-9.72c-5.28-4-21.55-12.67-21.55-12.67l-5.28.42-15.84 39.3 1.05 83.45 28.52 35.28z"
    opacity=".1"
  /><path
    d="M519.19 566.69l.56-85.64s-2.53-33.24 17.33-33.8c0 0 46.83.34 67.18 6.95a4.54 4.54 0 012.56 6.56c-4 7.05-10.88 25.72-14.18 73.6v51.34z"
    fill="#f5821f"
  /><path
    fill="#f5821f"
    d="M617.99 621.41l-85.22-1.99h-.08l-41.88-.97 4.85-55.99 23.24.85 73.95 16.48 22.6 35.49 2.54 6.13z"
  /><path
    opacity=".1"
    d="M617.99 621.41l-85.22-1.99h-.08l-41.88-.97 4.85-55.99 23.24.85 73.95 16.48 22.6 35.49 2.54 6.13z"
  /><path
    fill="#f5821f"
    d="M617.99 621.41l-85.22-1.99-1.4-37.52 61.48-2.11 22.6 35.49 2.54 6.13z"
  /><path
    d="M532.69 619.42l-41.88-1 4.86-56s13.1 20.92 35.7 19.44z"
    fill="#fff"
    opacity=".1"
  /><path
    d="M833.27 664.71c-1.69 16.06-13.1 13.52-13.1 13.52l-2.13-.19-21.11-1.92.85-24.93s11.49-.78 21.41 1.29c7.92 1.64 14.83 5.1 14.08 12.23z"
    fill="#dce0ed"
  /><path
    d="M540.03 421.34s-38.87 17.73-41.69 22.81-22 27-22 27l8.31 14 38.45-30.57z"
    fill="#4c4981"
  /><path
    d="M510.41 511.99l-18-2.69-13.24 15.62s-18.45 9.15-20.6 13.15-8.86 15.72-11.82 15.81-5.73 4.41-5.75 6.12-11.27 21.35-14.06 22.48-7.63 7.51-7.51 8.77-10.5 13.82-10.5 13.82-18 28.17-20.68 29.07-13.05 19.09-15.68 21.25-10 4.1-9.1 5.85 19 26.49 17.9 33.5c0 0 13.47-10.66 14-13.94s17.2-20.58 17.2-20.58l87.31-90.68 16.83-57.15z"
    fill="#ceddf9"
  /><path
    d="M558.75 541.12s3.59 41.22-8.31 47.46-20 5.52-22.29 8.27-16.24 5.18-17.72 7.68-40.57 24.35-40.57 24.35-26.74 15.76-30.93 19.19-27 13.46-30.89 18.18-28.31 20.19-28.31 20.19-7.15-22-15.37-23.93c0 0 19.76-3.89 20.93-7s7.07-6.45 7.07-6.45 28.13-16.32 29-20 7.8-8.92 7.8-8.92 11.17-15.27 15.28-16.74 28.48-26.49 28.48-26.49 16.57-8.76 18.41-11.64 33.24-19.2 33.24-19.2l-35.79-44.47 11.32-3.48 33.53 9 6 10.87z"
    opacity=".1"
  /><path
    d="M560.77 541.72s3.6 41.22-8.3 47.46-20 5.53-22.3 8.27-16.24 5.19-17.72 7.68-40.56 24.36-40.56 24.36-26.74 15.75-30.94 19.15-27 13.47-30.89 18.19-28.31 20.18-28.31 20.18-7.18-21.94-15.37-23.94c0 0 19.77-3.88 20.93-7s7.07-6.46 7.07-6.46 28.13-16.32 29-20 7.81-8.93 7.81-8.93 11.17-15.27 15.28-16.73 28.47-26.5 28.47-26.5 16.57-8.76 18.41-11.64-14.2-41-14.2-41l11.68-22.7 11.32-3.47 33.53 9 6 10.87z"
    fill="#ceddf9"
  /><path
    d="M600.57 433.84l-27.35 19s-33.05-12.26-20-17.18c8.56-3.23 11.64-19.9 12.74-31 .58-5.78.61-10 .61-10s37.29-.06 30.43 11.84a18.73 18.73 0 00-2.28 10.76c.52 8.81 5.85 16.58 5.85 16.58z"
    fill="#fec2be"
  /><path
    d="M594.66 417.27a26.22 26.22 0 01-28.76-12.57c.58-5.78.61-10 .61-10s37.29-.06 30.43 11.84a18.73 18.73 0 00-2.28 10.73z"
    opacity=".1"
  /><path
    d="M614 398.57a26.28 26.28 0 11.59-2.41c-.16.8-.35 1.61-.59 2.41z"
    fill="#fec2be"
  /><path
    d="M561.48 423.18s-4.59 0-4.88 6.53-4.93 6.05-4.93 6.05l-21.56 22.39s-9.68 23.18-9.6 24.12-2.18 4.86-1.67 6.84-.2 8-2 7.47-4.8 1.32-4.76 4.27-15.15 12-14.53 14.2 43.25 24.85 43.25 24.85l17.74 13.75 16.56-30.85 13.8-42.51 7.67-24.68 6.35-7.1-2.92-16.66s-2.62-7.21-4.76-6.2-10 9.5-17.38 10.24-11.69 1.64-13.41 0-12.17-2.82-2.97-12.71z"
    opacity=".1"
  /><path
    d="M562.96 421.01s-5.46.16-5.76 6.68-4.93 6.05-4.93 6.05l-21.56 22.39s-9.68 23.17-9.59 24.12-2.19 4.85-1.68 6.84-.19 8-2 7.47-4.81 1.32-4.77 4.27-15.15 12-14.52 14.2 43.24 24.85 43.24 24.85l17.75 13.75 16.56-30.86 13.8-42.51 7.74-24.67 6.34-7.1-2.92-16.66s-2.62-7.21-4.76-6.2-10 9.5-17.37 10.23-11.69 1.65-13.41 0-.69-3.51-2.16-12.85z"
    opacity=".1"
  /><path
    d="M562.76 421.68s-5.47.16-5.76 6.68-4.93 6.06-4.93 6.06l-21.56 22.38s-9.68 23.18-9.59 24.12-2.19 4.86-1.68 6.84-.19 8-2 7.47-4.8 1.32-4.76 4.27-15.15 12-14.52 14.2 43.24 24.86 43.24 24.86l17.74 13.74 16.56-30.85 13.81-42.51 7.73-24.68 6.35-7.1-2.92-16.66s-2.62-7.21-4.76-6.19-10 9.49-17.37 10.23-11.7 1.65-13.42 0-.69-3.47-2.16-12.86z"
    fill="#fff"
  /><path
    d="M562.95 421.65a40.53 40.53 0 01-7.55-1.48c-2.64-1-12.41-.22-12.41-.22s-11.22.69-13.29 3.93-11 20.77-14.06 21.87-21.15 30.22-24.85 32.78-19.64 33.79-19.64 33.79 11.78-5.56 17.17 2.58c.14.21.28.42.41.65 5.18 9.08 10 2.08 10 2.08s17.15-15.62 18.52-18.34 11.51-23.18 14.12-28.83 24.71-33.56 25.45-34.8 6.13-14.01 6.13-14.01z"
    opacity=".1"
  /><path
    d="M562.95 421.65a63.27 63.27 0 01-8.89-1.88c-2.65-1-12.42-.22-12.42-.22s-11.22.69-13.29 3.92-11 20.78-14.06 21.87-21.15 30.22-24.85 32.79-19.64 33.79-19.64 33.79 11.78-5.56 17.18 2.58c.13.2.27.42.4.65 5.18 9.07 10 2.08 10 2.08s17.16-15.63 18.52-18.34 11.51-23.18 14.12-28.83 24.71-33.56 25.45-34.81 7.48-13.6 7.48-13.6z"
    fill="#4c4981"
  /><path
    d="M595.78 422.69s14.18 10.29 16 13.41 20.39 12.88 20.39 12.88 7 12.92 5.95 17.57-2.16 9.08-1.25 11.56 1.47 2.46.12 5.73-.88 3.59 1 6.53-28 12-28 12-4 .62-4.43 2.53-23.34 52.32-26.65 60.33-13.77 40-22.55 40.45-2 .12-2 .12 1.35-26-4.05-35 5.26-43.73 5.26-43.73 35.49-102.12 40.21-104.38z"
    opacity=".1"
  /><path
    d="M595.78 422.69s15.53 10.7 17.35 13.81 20.44 12.88 20.44 12.88 7 12.92 5.95 17.57-2.16 9.09-1.25 11.56 1.47 2.46.12 5.73-.89 3.59 1 6.54-28 12-28 12-4 .63-4.43 2.53-23.39 52.34-26.72 60.34-13.77 39.95-22.55 40.42-2 .12-2 .12 1.35-26-4.05-35 5.35-43.75 5.35-43.75 34.07-102.49 38.79-104.75z"
    fill="#4c4981"
  /><path
    d="M613.8 525.62s-31.46 7-32.44 9-27 17.51-13.35 25 35.1-10.55 35.1-10.55l17-10.85z"
    fill="#fec2be"
  /><path
    d="M627.86 483.68c.51.15 11.47 7.1 11.47 7.1s5.16 17.14 6.29 21.34 4 11.67 3.81 13.07 3.12 9.19-2.16 12.75-10.82 3-13.36 5.38-20.05 10-22.26 10.6 10.92-26.11-5.29-30.22c0 0 11.61 1.09 12.21-.94s1.27-7.33-.9-9.26-11.54-11.16-11.54-11.16z"
    fill="#4c4981"
  /><path
    d="M614.57 396.16a7.22 7.22 0 01-3.13-3.28c-1.07-2.08-2.14-4.62-4.42-5.15-1.28-.31-2.83.07-3.78-.84-.74-.72-.72-1.89-.73-2.92a11.88 11.88 0 00-1.91-6.63 6.94 6.94 0 00-5.93-3.09c-3.25.22-6.08 3.18-9.28 2.59-1.41-.26-2.76-1.21-4.14-.84a4.07 4.07 0 00-1.46.82 21.27 21.27 0 00-6.67 9c-1.32 3.36-1.76 7-3.34 10.29-.63 1.28-1.84 2.65-3.2 2.25-2.12-.63-1-3.3-2.18-4.47a3.23 3.23 0 00-1.67-.67 26.21 26.21 0 1151.84 2.94z"
    opacity=".1"
  /><path
    d="M566.8 397.68c1.36.4 2.57-1 3.2-2.24 1.58-3.25 2-6.93 3.34-10.29a21.23 21.23 0 016.68-9 4.06 4.06 0 011.45-.83c1.38-.36 2.74.58 4.14.84 3.2.6 6-2.37 9.28-2.59a6.94 6.94 0 015.93 3.1 11.74 11.74 0 011.91 6.62c0 1 0 2.2.74 2.92.94.92 2.49.54 3.78.84 2.28.54 3.34 3.07 4.42 5.15s3.25 4.26 5.42 3.36c.65-.27 1.18-.8 1.85-1 1.23-.41 2.7.26 3.8-.42 1.4-.86 1-3 .09-4.43s-2-3-1.43-4.53a6.14 6.14 0 011.51-1.94 9.61 9.61 0 00-.58-13.19c-.89-.8-1.93-1.42-2.8-2.24-1.75-1.64-2.68-3.94-4-6a18.28 18.28 0 00-6.37-6 9.1 9.1 0 00-3.7-1.29c-1.81-.14-3.59.54-5.4.72-6.06.61-11.27-4.18-17.2-5.54a4.88 4.88 0 00-4.07.48c-1.18.92-1.43 2.57-2 4-1.19 3.06-4.07 5.2-7.13 6.38-3.53 1.35-8 2.08-9.47 5.55-1.28 3 .38 6.44-.29 9.6-.52 2.47-2.37 4.4-3.8 6.48s-2.48 4.88-1.24 7.08a6.3 6.3 0 003.24 2.53c1.66.68 5.36.32 6.48 1.42s.1 3.85 2.22 4.46z"
    fill="#9a5e7f"
  /><path
    d="M626.04 513.73c.6.06 11.53 2 14.1 5.68s-14.1-5.68-14.1-5.68zM620.57 502.07s11.92 2.7 13.3 3.85-13.3-3.85-13.3-3.85zM624.49 472.64s8.77 3.84 9.77 6.22-9.77-6.22-9.77-6.22zM512.41 572.07c.91.64 22.45 16.62 20.69 17.2s-20.69-17.2-20.69-17.2zM512.25 582.07s12.62 6.1 10.51 8.65-10.51-8.65-10.51-8.65z"
    opacity=".1"
  /><g opacity=".1"><path d="M560.36 374.36c.57-2.71-.57-5.64-.1-8.3v.05c-1.26 2.92.33 6.33-.26 9.45a8.36 8.36 0 00.36-1.2zM621.8 383.81a2.57 2.57 0 00-.14.82 11.07 11.07 0 011.25-1.41 8.72 8.72 0 002.11-4.14 8.47 8.47 0 01-1.71 2.79 6.14 6.14 0 00-1.51 1.94zM623.15 392.77c-1.1.68-2.58 0-3.81.42-.67.23-1.2.75-1.85 1-2.17.9-4.35-1.27-5.42-3.35s-2.14-4.62-4.42-5.16c-1.28-.3-2.84.08-3.78-.84-.74-.71-.72-1.88-.74-2.91a11.85 11.85 0 00-1.9-6.63 7 7 0 00-5.94-3.1c-3.24.22-6.07 3.19-9.27 2.6-1.41-.27-2.77-1.21-4.15-.85a4.21 4.21 0 00-1.45.83 21.23 21.23 0 00-6.68 9 30.38 30.38 0 00-1 2.93c.17-.53.35-1.06.56-1.58a21.23 21.23 0 016.68-9 4.06 4.06 0 011.45-.83c1.38-.36 2.74.58 4.14.84 3.2.6 6-2.37 9.28-2.59a6.94 6.94 0 015.93 3.1 11.74 11.74 0 011.91 6.62c0 1 0 2.2.74 2.92.94.92 2.49.54 3.78.84 2.28.54 3.34 3.07 4.42 5.15s3.25 4.26 5.42 3.36c.65-.27 1.18-.8 1.85-1 1.23-.41 2.7.26 3.8-.42a2 2 0 00.9-1.8 1.77 1.77 0 01-.45.45zM570.4 394.07c-.62 1.28-1.84 2.64-3.2 2.24-2.12-.62-1-3.29-2.17-4.46s-4.82-.74-6.48-1.42a6.34 6.34 0 01-3.24-2.53 4.79 4.79 0 01-.42-3.39 5.47 5.47 0 000 4.74 6.3 6.3 0 003.24 2.53c1.66.68 5.36.32 6.48 1.42s.05 3.84 2.17 4.46c1.36.4 2.57-1 3.2-2.24a26.15 26.15 0 001.55-4.32 21.44 21.44 0 01-1.13 2.97z" /></g><path
    d="M525.78 444.37s-8.61 12.85-7.58 15.54 7.58-15.54 7.58-15.54zM527.04 486.24s4.57 1.91 6.24 3.7-6.24-3.7-6.24-3.7zM537.08 499.34s9.76 2.36 10.59 3.89-10.59-3.89-10.59-3.89zM538.78 512.7s8.83 1.16 9.83 4.58-9.83-4.58-9.83-4.58zM833.27 664.71c-1.69 16.06-13.1 13.52-13.1 13.52l-2.13-.19a21.57 21.57 0 01-3.36-12.06c0-5.59 1.78-10.53 4.51-13.5 7.92 1.64 14.83 5.1 14.08 12.23z"
    opacity=".1"
  /><path
    d="M506.79 454.29c-19.29 0-34.92 21.13-34.92 47.19s15.63 47.18 34.92 47.18 34.93-21.13 34.93-47.18-15.63-47.19-34.93-47.19zm-4.93 84.51c-14.7 0-26.61-15.32-26.61-34.23s11.91-34.22 26.61-34.22 26.62 15.32 26.62 34.22-11.91 34.23-26.62 34.23z"
    fill="#636780"
  /><path
    fill="#636780"
    d="M508.48 515.99l16.34 16.05 5.91-14.37-23.66-13.8 1.41 12.12z"
  /><path
    fill="#f5821f"
    d="M532.57 357.07l14.22 1.73 5.28 6.27-8 36-17 58-11.16 39.82-7.84 24.18-5 32-5 22-15 15-30.5-36-5-12-12-24.5 31-14.5 34-3 16-41 13-47.5 3-56.5z"
  /><path
    fill="#f5821f"
    d="M244.82 528.66l-18.59 156.06 234.08-9.86-27.04-76.62-45.07-29.3 103.1 1.69.56-42.81-41.69-9.02-83.94-6.76-63.1-2.81-60.28 19.71"
  /><path
    opacity=".1"
    d="M244.82 528.66l-18.59 156.06 234.08-9.86-27.04-76.62-45.07-29.3 103.1 1.69.56-42.81-41.69-9.02-83.94-6.76-63.1-2.81-60.28 19.71"
  /><path
    d="M564.63 684.18c0 38.78-12.89 74.08-48.64 70.22-45.09-1-48.63-31.44-48.63-70.22s21.77-67.64 48.63-67.64 48.64 28.86 48.64 67.64z"
    fill="#636780"
  /><path
    d="M564.91 684.25c0-30-13.05-54.1-31.41-63.44-23.58 4.48-41.7 31.6-41.7 67 0 31.78 2.38 58 28.06 66.93 33.03 1.17 45.05-33.04 45.05-70.49z"
    opacity=".1"
  /><path
    fill="#f5821f"
    d="M610.57 623.32l-13.75 15.75 24.75-4.25 18.5-17 16.5-33 23.25-14.25 57 7.75 52.75 2 19.47-17.29-21.72-2.96-22-.5-55.25-1.25-65.75-1.75-13.5 36-10.25 24.75-10 6z"
  /><path
    d="M799.75 687.53c-1.13 1.69-38 7.33-38 7.33l-102 18.59-175.18 2.53-20.56-17.47-10.8 1.92-.44.08-144.28 25.61-2.35-.33-39.32-5.61-205.37-29.27 2.3-29.81 1.36-17.6 2.81-36.53 2-9.58 18.29-1.68 8.54-.78 133.29-12.23 17.43-1.6 9.77-.89 95.21-13 138.87 3.38.56-42.82 54.93-169c12.11 2 11.83 10.14 11.83 10.14l-46.77 159.16-.57 97.75c97.25 9.82 100.39-11.37 115.77-4.23l18.6-59.43 163.37.85c6.53 7.9-9.29 124.52-9.29 124.52z"
    fill="#f5821f"
  /><path
    fill="#f5821f"
    d="M394.4 598.8l51.83 111.27 17.46 5.63 4.23-18.03-19.44-61.69-20-35.77-34.08-1.41z"
  /><path
    opacity=".15"
    d="M394.4 598.8l51.83 111.27 17.46 5.63 4.23-18.03-19.44-61.69-20-35.77-34.08-1.41z"
  /><ellipse
    cx="360.66"
    cy="721.33"
    rx="93.87"
    ry="106.48"
    fill="#636780"
  /><path
    d="M394.15 621.5c-49.12 3.42-88 49.68-88 106.26 0 45.61 25.28 84.52 60.81 99.68 49.12-3.42 88-49.68 88-106.26 0-45.61-25.28-84.52-60.81-99.68z"
    opacity=".1"
  /><path
    d="M109.05 535.14l-4.65 21.93-14.22 67.11-61.13-5.92s-3.66-11.26 5.92-15.49c0 0 3.14-38.13 14.44-50.14a11.39 11.39 0 014.43-3.09z"
    fill="#f5821f"
  /><path
    d="M104.4 557.07l-14.22 67.11-61.13-5.92s-3.66-11.26 5.92-15.49c0 0 3.14-38.13 14.44-50.14z"
    fill="#fff"
    opacity=".1"
  /><path
    d="M246.8 541.07c7.88 13.22-11.23 135.19-11.23 135.19L85.39 651.47l5.35-106.76c3.1-19.15 14.37-21.4 14.37-21.4 53-26.76 174.64-32.4 174.64-32.4 111 4.22 212.11 36.9 212.11 36.9-126.19-19.43-245.06 13.26-245.06 13.26z"
    fill="#f5821f"
  /><path
    d="M235.57 676.26L85.39 651.47l5.35-106.76c3.1-19.15 14.37-21.4 14.37-21.4s109.57-10.43 141.69 17.76c7.88 13.22-11.23 135.19-11.23 135.19z"
    opacity=".1"
  /><path
    d="M219.66 669.22L94.12 648.07l4.45-91.09c2.59-16.34 12-18.26 12-18.26s91.62-8.9 118.47 15.14c6.63 11.29-9.38 115.36-9.38 115.36z"
    fill="#f5821f"
  /><ellipse
    cx="209.33"
    cy="594.29"
    rx="17.18"
    ry="31.27"
    opacity=".1"
  /><ellipse
    cx="209.33"
    cy="593.45"
    rx="17.18"
    ry="31.27"
    fill="#dce0ed"
  /><path
    d="M211.57 570.35s-7 1.12-3.38 10.42 4.22 14.08 4.22 14.08 7 3.67 6.76-8.45-7.6-16.05-7.6-16.05z"
    fill="#f0f0f4"
  /><ellipse
    cx="117.22"
    cy="581.9"
    rx="16.06"
    ry="29.22"
    opacity=".1"
  /><ellipse
    cx="117.22"
    cy="581.05"
    rx="16.06"
    ry="29.22"
    fill="#dce0ed"
  /><path
    d="M119.47 557.95s-7 1.13-3.38 10.43 4.23 14.08 4.23 14.08 7 3.66 6.76-8.45-7.61-16.06-7.61-16.06z"
    fill="#f0f0f4"
  /><path
    d="M189.57 567.81c-1.12 11.55-6.76 97.18-6.76 97.18l-9.56-1.6-5.31-.87-7.08-1.19-.86-.14-27.89-4.65 5.51-90.83a11.36 11.36 0 0111.54-10.64 8.06 8.06 0 01.85 0c1.93.17 4 .37 6.17.61.91.1 1.84.2 2.77.32 2.68.32 5.45.71 8.16 1.15 1.38.24 2.74.49 4.09.75 2.27.45 4.47.95 6.5 1.52 1.37.38 2.68.79 3.88 1.24 5.04 1.82 8.33 4.17 7.99 7.15z"
    opacity=".1"
  /><path
    d="M149.16 555.07l-5.46 102-3.1-.28 5.41-101.41a11.29 11.29 0 013.15-.31zM158.95 555.99l-5.11 103.08h-4.79l7.13-103.41c.91.11 1.84.21 2.77.33zM171.2 557.89l-8.06 103.44h-3.11v-.14l7.07-104c1.39.19 2.75.44 4.1.7zM181.57 560.65l-8.29 102.74v.2l-5.35-.57v-.5l9.72-103.11c1.42.38 2.73.79 3.92 1.24z"
    fill="#f5821f"
  /><path
    d="M67.01 640.21s-10.35-53.45 13.31-56.2 101.41 3 99.08 24.93-4.83 55.35-4.83 55.35l-16.05-3.59s12-50.28-6.76-52.18-64.86-7.19-64.86-7.19-12.47-2.11-5.28 42z"
    opacity=".1"
  /><path
    d="M67.01 645.28s-10.35-56.83 13.31-59.58 101.41 3 99.08 24.93-4.83 55.35-4.83 55.35l-16.05-3.59s12-50.28-6.76-52.18-64.89-7.14-64.89-7.14-12.47 1.27-5.28 45.43z"
    fill="#dce0ed"
  /><path
    d="M484.57 715.98l-20.84-.28c-15.21-67-40.29-108.73-40.29-108.73-8.48-4.51-100.87-3.9-100.87-3.9-9.58 1.69-12.11 32.12-12.11 32.12s8.17 7 .28 11.55c-3.52 2-15.12 2.39-28.48 1.7-16.58-.86-35.9-3.38-45.88-6.49-18-5.64-3.67-16.06-3.67-16.06s2.54-3.38 4.23-22a75.25 75.25 0 0110.28-30.69c.78-1.29 1.27-2 1.27-2a9.65 9.65 0 013.29-2.06c23.88-10 140.93-.48 140.93-.48l43.38 13.81c1.2.48 3.05 3.54 5.33 8.43 13.71 29.39 43.15 125.08 43.15 125.08z"
    fill="#f5821f"
  /><path
    d="M484.57 715.98l-20.84-.28c-15.21-67-40.29-108.73-40.29-108.73-8.48-4.51-100.87-3.9-100.87-3.9-9.58 1.69-12.11 32.12-12.11 32.12s8.17 7 .28 11.55c-3.52 2-15.12 2.39-28.48 1.7-16.58-.86-35.9-3.38-45.88-6.49-18-5.64-3.67-16.06-3.67-16.06s2.54-3.38 4.23-22a75.25 75.25 0 0110.28-30.69c.78-1.29 1.27-2 1.27-2a9.65 9.65 0 013.29-2.06c23.88-10 140.93-.48 140.93-.48l43.38 13.81c1.2.48 3.05 3.54 5.33 8.43 13.71 29.39 43.15 125.08 43.15 125.08z"
    opacity=".1"
  /><path
    d="M441.42 590.89c-40-15.56-150.4-7.3-150.4-7.3-11.72-10-33.77-10.68-43.8-10.41.78-1.29 1.27-2 1.27-2a9.65 9.65 0 013.29-2.06c23.88-10 140.93-.48 140.93-.48l43.38 13.81c1.2.49 3.05 3.55 5.33 8.44z"
    fill="#f5821f"
  /><path
    d="M297.5 587.81c-2.53 8.73-12.93 43.67-12.93 43.67a147.84 147.84 0 00-2.29 16.91c-16.58-.86-35.9-3.38-45.88-6.49-18-5.64-3.67-16.06-3.67-16.06s2.54-3.38 4.23-22a74.87 74.87 0 0111.55-32.68 9.65 9.65 0 013.29-2.06c15.64 3.72 47.62 12.1 45.7 18.71z"
    fill="#f5821f"
  /><path
    d="M297.5 587.81c-2.53 8.73-12.93 43.67-12.93 43.67a147.84 147.84 0 00-2.29 16.91c-16.58-.86-35.9-3.38-45.88-6.49-18-5.64-3.67-16.06-3.67-16.06s2.54-3.38 4.23-22a74.87 74.87 0 0111.55-32.68 9.65 9.65 0 013.29-2.06c15.64 3.72 47.62 12.1 45.7 18.71z"
    fill="#fff"
    opacity=".1"
  /><path
    d="M323.28 365.98c-11.2 1.69-16.06 24.93-16.06 24.93L276.8 492.53l215.06 35.28 54.93-169c-50.49-22.83-223.51 7.17-223.51 7.17zm173 108.59s-1.27 9.72-9.51 10.57l-139.43-5.45-28.6-1.13-9.59-.37h-.68s-10.57 1.9-8.88-7c0 0 11.62-84.5 32.12-90.84 0 0 2.13-.45 5.86-1.15 5.86-1.11 15.64-2.85 27.16-4.44 5.16-.71 10.67-1.39 16.34-2 15.49-1.58 32.14-2.43 45.92-1.1 0 0 102.67-9.51 95.28 13.31.02.03-21.53 82.63-25.97 89.6z"
    fill="#f5821f"
  /><path
    d="M309.17 478.19h-.68s-10.57 1.9-8.88-7c0 0 11.62-84.5 32.12-90.84 0 0 2.13-.45 5.86-1.15-7.44 14.52-31.32 64.23-28.42 98.99z"
    fill="#f5821f"
  /><path
    d="M309.17 478.19h-.68s-10.57 1.9-8.88-7c0 0 11.62-84.5 32.12-90.84 0 0 2.13-.45 5.86-1.15-7.44 14.52-31.32 64.23-28.42 98.99zM328.1 686.62a13.6 13.6 0 01-12.73 7.14l-4.31-.19-40.61-1.75-14.64-.63-13.52-1.12-178.54-29 1.36-17.6 20.53 2.94 8.5 1.22 126.05 18 16.59 2.44 8.05 1.15 34.09-.25 36.9-.27a13.88 13.88 0 015.44 1 13.23 13.23 0 017.15 6.79 11.11 11.11 0 01-.31 10.13z"
    opacity=".1"
  /><path
    d="M328.1 688.31a13.6 13.6 0 01-12.73 7.14l-59.56-2.57-13.52-1.13-190.4-30.89-15-2.43-8.12-1.36c-16.05-3.38-11.26-19.44-11.26-19.44 1.12-7.33 28.73-14.09 37.74-13.8 6.06.19 6.9 9.52 6.8 15.63 0 3-.32 5.21-.32 5.21l8.91 1.28 174.19 24.92 71-.52a13.64 13.64 0 0112.59 7.84 11.11 11.11 0 01-.32 10.12z"
    fill="#dce0ed"
  /><path
    d="M42.29 634.01s7.61 9.29 19.44 10.7c0 0-4.79-10.42-19.44-10.7zM40.32 660.21s-25.07-.57-25.07 13 15.78 15.78 15.78 15.78l223.94 43.08 63.66 1.12s22.25-17.74-.85-25.63l-64.21 1.66-213.53-39.15s5.63-7.61.28-9.86z"
    opacity=".1"
  /><path
    d="M318.63 734.85l-63.66-1.12-199.12-38.32-14.57-2.81-10.25-2s-15.78-2.26-15.78-15.78c0-9.7 12.92-12.15 20.21-12.76 2.87-.23 4.86-.19 4.86-.19 5.35 2.25-.28 9.85-.28 9.85l7.77 1.43 205.76 37.76 64.22-1.69c23.09 7.85.84 25.63.84 25.63z"
    fill="#dce0ed"
  /><path
    d="M59.19 649.22l13.24-5.92 6.76-.28-.56 56.9-20.84-4.22-8.74-5.63-4.22-23.66s1.69-9.86 2.53-10.7 11.83-6.49 11.83-6.49z"
    fill="#dce0ed"
  /><path
    d="M59.19 649.22l13.24-5.92 6.76-.28-.56 56.9-20.84-4.22-8.74-5.63-4.22-23.66s1.69-9.86 2.53-10.7 11.83-6.49 11.83-6.49z"
    opacity=".1"
  /><path
    d="M55.85 695.41l.24.29-14.64-2.82-.17-.28c-7.71-12.45-8.38-22.53-5.82-30.53 2.87-.23 4.86-.19 4.86-.19 5.35 2.25-.28 9.85-.28 9.85l7.77 1.43c-.52 11.16 6.61 20.49 8.04 22.25zM77.51 643.07q-3.72 1.42-6.87 3c-9.48 4.56-15.33 9.68-18.75 14.87l-15-2.43c6.49-13.48 22-19.64 22-19.64l3.14.71z"
    opacity=".1"
  /><path
    d="M60.57 638.8s-41.12 16.34-17.46 54.08l14.65 2.82s-29-33.24 21.4-52.68zM158.63 657.11l15.21-.56-2.54 61.12-24.51-4.5-10.42-5.07-4.79-12.12-3.38-12.11 8.17-10.99 9.3-6.19 12.96-9.58z"
    fill="#dce0ed"
  /><path
    opacity=".1"
    d="M158.63 657.11l15.21-.56-2.54 61.12-24.51-4.5-10.42-5.07-4.79-12.12-3.38-12.11 8.17-10.99 9.3-6.19 12.96-9.58z"
  /><ellipse
    cx="156.94"
    cy="688.66"
    rx="7.32"
    ry="12.39"
    fill="#dce0ed"
  /><path
    d="M103.77 723.23c-2.11-10.77-10.35-13.1-10.35-13.1s-15.85-4.64-16.27 12.94c0 0 .21 10.78 7.4 14.16l.42 12s.63 11.2-5.71 10.14-5.49-11-5.49-11-3.38-10.56-11.62-5.07c0 0-1.9 5.92 2.33 8.88 2.46 1.72 2.55 5.24 2.2 7.88a11.46 11.46 0 002.64 9.18 10.65 10.65 0 0010.16 3.64 15.76 15.76 0 008.8-5.06 23.08 23.08 0 006.1-15.39l.31-15.46s11.19-2.96 9.08-13.74zm-13 10.88a9 9 0 119-9 9 9 0 01-8.99 8.96z"
    fill="#dce0ed"
  /><path
    d="M87.09 705.48a4 4 0 00-2 5.55c1.66 3.11 3.65 7.13 3.46 8.19-.32 1.79 3.7.32 4.22-.11s7.82 0 8.24-5-3.9-7.61-3.9-7.61l1.69-10.88-10-.84.11 9.93z"
    fill="#636780"
  /><path
    d="M87.09 705.48a4 4 0 00-2 5.55c1.66 3.11 3.65 7.13 3.46 8.19-.32 1.79 3.7.32 4.22-.11s7.82 0 8.24-5-3.9-7.61-3.9-7.61l1.69-10.88-10-.84.11 9.93z"
    opacity=".1"
  /><path
    d="M89.83 705.28s3.38 11.62 1.9 12-1.9-12-1.9-12zM93.63 702.53s3.38 11.62 1.9 12-1.9-12-1.9-12z"
    opacity=".1"
  /><path
    d="M134.13 667.53l-5.64 34.93s-7-.95-10.82-1.78a7.8 7.8 0 01-2.42-.75c-.2-.2-.61-.18-1.16-.07-1.88.38-5.22 1.93-5.87.62a.93.93 0 00-.19-.27c-.66-.72-1.94-.2-3.18 0a2.7 2.7 0 01-2-.26c-1-.7-3.15.42-4.87.79-1.09.24-2 .19-2.46-.79a2.27 2.27 0 00-1.68-1.2c-1.62-.41-3.89-.13-5.2-.41-.52-.1-.87-.3-1-.65-.26-.76-1.71-1.12-3.26-1.42-1.89-.36-3.92-.63-4.07-1.39 0-.26-.23-.37-.51-.38a17.46 17.46 0 00-3.08.76c-.84.22-1.55.22-1.75-.38s-1.19-.6-2.3-.33c-.89.22-1.88.57-2.64.75s-1.18.18-1.26-.15c-.28-1.12-3.94 1.42-4.78-.84s-12.42-17.24 2.58-36.64c0 0 4 .28 7.12.84a11.17 11.17 0 013 .84c1.07.61 3.36.48 5.43.63a7 7 0 013 .72 2 2 0 01.85.9c.47 1.07 1.55 1.29 2.73 1.23 1.6-.1 3.38-.7 4-.38h.06c1.18.51 5.6 0 6.35.75l.06.07c.32.47 2 0 3.82-.26 1.37-.18 2.75-.2 3.5.55a3.82 3.82 0 002.74.81 16.13 16.13 0 013.59.14 1.53 1.53 0 01.71.45c.71.89 2.43.77 4 .85a4.08 4.08 0 012.24.56 2.1 2.1 0 00.81.34c2.16.5 6.79-.34 6.79-.34z"
    fill="#636780"
  /><path
    d="M72.67 694.53c-.89.22-1.88.57-2.64.75-11.44-17.75-1.81-31.23 3.61-36.77a11.17 11.17 0 013 .84c-11.51 13.26-6.17 29.82-3.97 35.18z"
    opacity=".1"
  /><path
    d="M79.81 694.48a17.46 17.46 0 00-3.08.76c-9.79-17.31.28-30.26 5.37-35.25a7 7 0 013 .72c-10.95 11.98-7.7 26.89-5.29 33.77z"
    opacity=".1"
  /><path
    d="M88.64 698.32c-.52-.1-.87-.3-1-.65-.26-.76-1.71-1.12-3.26-1.42-8.59-15.68-.91-27.73 4.3-33.41 1.6-.1 3.38-.7 4-.38h.06c-12.08 13.61-6.23 30.81-4.1 35.86z"
    opacity=".1"
  /><path
    d="M97.99 700.72c-1.09.24-2 .19-2.46-.79a2.27 2.27 0 00-1.68-1.2c-10-17.47.2-30.53 5.29-35.5l.06.07c.32.47 2 0 3.82-.26-14.24 14.37-6.92 33.45-5.03 37.68z"
    opacity=".1"
  /><path
    d="M108.01 700.2c-.66-.72-1.94-.2-3.18 0-10.44-17.34-.85-30.44 4.43-35.79a16.13 16.13 0 013.59.14c-12.19 13.11-7.16 29.82-4.84 35.65z"
    opacity=".1"
  /><path
    d="M117.67 700.68a7.8 7.8 0 01-2.42-.75c-.2-.2-.61-.18-1.16-.07-9.25-15.84-1.87-28.07 3.44-34a4.08 4.08 0 012.24.56 2.1 2.1 0 00.81.34c-10.12 13.04-5.01 28.76-2.91 33.92z"
    opacity=".1"
  /><ellipse
    cx="390.74"
    cy="726.41"
    rx="45.91"
    ry="67.6"
    fill="#636780"
  /><ellipse
    cx="389.19"
    cy="727.39"
    rx="33.38"
    ry="54.79"
    opacity=".1"
  /><ellipse
    cx="389.19"
    cy="725.7"
    rx="33.38"
    ry="54.79"
    fill="#f0f0f4"
  /><ellipse
    cx="395.24"
    cy="688.94"
    rx="3.94"
    ry="6.76"
    fill="#636780"
  /><ellipse
    cx="411.02"
    cy="748.1"
    rx="3.94"
    ry="6.76"
    fill="#636780"
  /><ellipse
    cx="368.48"
    cy="719.93"
    rx="3.94"
    ry="6.76"
    fill="#636780"
  /><ellipse
    cx="380.03"
    cy="759.36"
    rx="3.94"
    ry="6.76"
    fill="#636780"
  /><path
    d="M726.79 601.33s33 87.89 31.27 93.38c0 0 13.94 8.45 17.32 6.34s.43-41 .43-41l-6.34-34.22-7.19-20.28z"
    fill="#f5821f"
  /><path
    d="M726.79 601.33s33 87.89 31.27 93.38c0 0 13.94 8.45 17.32 6.34s.43-41 .43-41l-6.34-34.22-7.19-20.28z"
    opacity=".15"
  /><ellipse
    cx="416.65"
    cy="711.48"
    rx="3.94"
    ry="6.76"
    fill="#636780"
  /><ellipse
    cx="395.24"
    cy="727.81"
    rx="11.55"
    ry="16.06"
    fill="#636780"
  /><path
    d="M763.57 718.8c0 50.87-16.9 97.18-63.8 92.11-59.15-1.27-63.8-41.24-63.8-92.11s28.54-88.73 63.78-88.73 63.82 37.85 63.82 88.73z"
    fill="#636780"
  /><path
    d="M763.92 718.88c0-39.38-17.12-71-41.21-83.22-30.93 5.88-54.7 41.46-54.7 87.87 0 41.69 3.13 76 36.81 87.8 43.33 1.56 59.1-43.26 59.1-92.45z"
    opacity=".1"
  /><path
    d="M788.48 697.25s-8.45 7.18-13.1 2.11c0 0-11.41-91.27-25.77-91.69l-49.44-.42s-5.91 2.53-8.45 13.52l-32 91-175.15 2.52-13.38-28 144.93.42v-.06c.78-2.81 25-89.28 41.27-100a7 7 0 011.79-.87s60.42-8 80.28-2.54c0 0 20.7 4.65 25.77 11 .68.71 8.52 9.54 10.95 35z"
    opacity=".1"
  /><path
    d="M788.48 698.94s-8.45 7.18-13.1 2.11c0 0-11.41-91.27-25.77-91.69l-49.44-.42s-5.91 2.53-8.45 13.52l-32 91-175.15 2.52-13.38-28 144.93.42v-.06c.78-2.81 25-89.28 41.27-100a7 7 0 011.79-.87s60.42-8 80.28-2.54c0 0 20.7 4.65 25.77 11v.05c.68.71 8.52 9.54 10.95 35z"
    fill="#f5821f"
  /><path
    d="M788.48 698.94s-8.45 7.18-13.1 2.11c0 0-11.41-91.27-25.77-91.69l-49.44-.42s-5.91 2.53-8.45 13.52l-32 91-175.15 2.52-13.38-28 144.93.42v-.06c.78-2.81 25-89.28 41.27-100a7 7 0 011.79-.87s60.42-8 80.28-2.54c0 0 20.7 4.65 25.77 11v.05c.68.71 8.52 9.54 10.95 35z"
    opacity=".1"
  /><path
    d="M681.16 599.22c-4.23 8-40.56 106.9-40.56 106.9l-24.51-17.75v-.06c.78-2.81 25-89.37 41.29-100 10.6 1.76 26.65 5.46 23.78 10.91z"
    fill="#f5821f"
  /><path
    d="M633.84 554.01l-19.86 65.06-103.52-3 .84 9.72s81.13 11.83 115.77-4.23l18.6-59.43 163.37.84-31.12-7.32z"
    fill="#f5821f"
  /><path
    d="M633.84 554.01l-19.86 65.06-103.52-3 .84 9.72s81.13 11.83 115.77-4.23l18.6-59.43 163.37.84-31.12-7.32z"
    fill="#fff"
    opacity=".1"
  /><path
    d="M148.49 656.54S93 684.43 134.12 710.63l11 2.53s-40.28-29 27-56.62z"
    opacity=".1"
  /><path
    d="M150.18 656.54s-55.49 27.89-14.37 54.09l11 2.53s-40.28-29 27-56.62z"
    fill="#dce0ed"
  /><ellipse
    cx="724.25"
    cy="725.98"
    rx="30.84"
    ry="52.82"
    fill="#636780"
  /><ellipse
    cx="723.21"
    cy="727.12"
    rx="22.42"
    ry="42.8"
    opacity=".1"
  /><ellipse
    cx="723.21"
    cy="725.43"
    rx="22.42"
    ry="42.8"
    fill="#f0f0f4"
  /><ellipse
    cx="727.28"
    cy="696.71"
    rx="2.65"
    ry="5.28"
    fill="#636780"
  /><ellipse
    cx="737.88"
    cy="742.93"
    rx="2.65"
    ry="5.28"
    fill="#636780"
  /><ellipse
    cx="709.3"
    cy="720.92"
    rx="2.65"
    ry="5.28"
    fill="#636780"
  /><ellipse
    cx="717.06"
    cy="751.73"
    rx="2.65"
    ry="5.28"
    fill="#636780"
  /><ellipse
    cx="741.66"
    cy="714.32"
    rx="2.65"
    ry="5.28"
    fill="#636780"
  /><ellipse
    cx="727.28"
    cy="727.08"
    rx="7.76"
    ry="12.54"
    fill="#636780"
  /><path
    d="M276.37 491.07s93.81 3.38 215.49 36.76z"
    opacity=".1"
  /><path
    d="M723.92 326.84s-5.09.82-2.44 7.54 3.09 10.19 3.09 10.19 5.1 2.65 4.89-6.12-5.54-11.61-5.54-11.61z"
    fill="#dce0ed"
  /><path
    d="M474.41 463.07l-.06.08a9.54 9.54 0 00-2 4.61c-.82 5.34-1.6 16.28 6.17 14.47a24 24 0 0011.58-6.29 9.49 9.49 0 002.57-7 7.3 7.3 0 00-3.21-6.1l-2.89-1.66a5 5 0 00-2.7-.7l-5 .18a6.24 6.24 0 00-4.46 2.41z"
    fill="#fec2be"
  /><path
    d="M530.57 371.57l-14.93 74.18-10.57 22.32 7 13 15.5-36.5s17-53.5 17-55-14-18-14-18z"
    fill="#f5821f"
  /></svg>
</template>

<script>
import { mergeFunctionalRenderContextClasses } from '@/helpers/utils'

export default {
  methods: {
    mergeFunctionalRenderContextClasses
  }
}
</script>
